export default __webpack_public_path__ + "static/img/conf_settings.2387f73.svg";